module.exports = window.__LR__.dependencies.load("ui-copilot");